import {HeaderDesktop} from '@logistics-frontend/order-layout-blocks'
import React, {memo} from 'react'

import {User} from 'src/shared/components/desktop'

import {controlPanelData, linksList} from './consts'

type Props = {}

export const Header = memo(function Header(_: Props): React.ReactElement<Props> {
  return <HeaderDesktop controlPanelData={controlPanelData} linksList={linksList} user={<User />} />
})
